import * as React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import queryString from 'query-string';
import * as H from 'history';
import { storage } from './storage';

export const RRLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => (
    <RouterLink innerRef={ref} {...props} />
));

export function getQueryParams(history: H.History) {
    const path = history.location.search;
    return queryString.parse(path) as any;
}

export function toQueryString(values: any): string {
    // TODO: write my own.
    return queryString.stringify(values);
}

const REDIRECT_KEY = 'redirect';
export async function handleRedirect(history: H.History) {
    const oldLocation = await storage.get(REDIRECT_KEY);
    console.log({ oldLocation });
    if (oldLocation) {
        await storage.remove(REDIRECT_KEY);
        history.push(oldLocation);
    } else {
        history.push('/');
    }
}

export async function saveLocationForRedirect(history: H.History) {
    await storage.save(REDIRECT_KEY, history.location);
}
